import iconsPng from '@/assets/img/png/icons';
import CustomButton from '@/components/atoms/CustomButton';
import colors from '@/theme/colors';
import { Image, Text, VStack } from '@chakra-ui/react';
import { OverviewButtonProps } from '.';

const NoInsightsOverviewComponent = ({
  overviewBottomButtonOnClick,
  overviewBottomButtonLabel = 'Take Screener',
  overviewBottomButtonIconPath,
  overviewBottomButtonIconSize,
  overviewDescription = 'This is your first Wholeness Screener. You’ll start seeing your progress once you’ve completed another one.',
}: OverviewButtonProps) => {
  return (
    <VStack width={'100%'} gap={'24px'} justifyContent={'space-between'} height={'100%'}>
      <VStack gap={'10px'}>
        <Text variant={'urbanistBold20'} color={'text.darkBlue'} marginTop={'4px'}>
          Wholeness Overview
        </Text>
        <Text variant={'urbanistMedium'} color={'text.mediumGray'}>
          Here you will see overview of your wholeness.
        </Text>
      </VStack>

      <VStack>
        <Image src={iconsPng.notepadWithPenOnScreen} width={150} height={150} alt="notepadWithPenOnScreen" />
      </VStack>

      <VStack gap={'20px'}>
        <Text variant={'urbanistSemiBold'}>{overviewDescription}</Text>
        <Text variant={'urbanistMedium'} color={'text.mediumGray'} textAlign={'center'}>
          We recommend re-taking the screener every 30 days so you can track, measure, and improve your progress!
        </Text>
      </VStack>

      {overviewBottomButtonOnClick ? (
        <CustomButton
          label={overviewBottomButtonLabel}
          onClick={overviewBottomButtonOnClick}
          iconBeforeLabelSvgPath={overviewBottomButtonIconPath}
          iconBeforeLabelSvgSize={overviewBottomButtonIconSize}
          iconBeforeLabelSvgColor={colors.extra.white}
          labelColor={colors.extra.white}
          backgroundColor="primary.500"
          hoverBackgroundColor="primary.600"
          borderColor={colors.primary[500]}
          width={'100%'}
        />
      ) : (
        <VStack height={'50px'} />
      )}
    </VStack>
  );
};

export default NoInsightsOverviewComponent;
